import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";

export function Layout() {
  const [open, setOpen] = useState(false);
  // La pagina Canali usa tutta la larghezza: albero, dettagli e chat affiancati.
  const wide = useLocation().pathname.startsWith("/canali");
  return (
    <div className="flex h-screen w-full overflow-hidden bg-[#0B0C10]">
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {open && (
        <div className="fixed inset-0 z-50 md:hidden">
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setOpen(false)} />
          <div className="absolute left-0 top-0 h-full animate-fade-up">
            <Sidebar onNavigate={() => setOpen(false)} />
          </div>
        </div>
      )}

      <div className="flex min-w-0 flex-1 flex-col">
        <header className="glass flex items-center gap-3 border-b border-white/5 px-4 py-3 md:hidden">
          <button
            onClick={() => setOpen(true)}
            data-testid="mobile-menu-button"
            className="rounded-lg p-1.5 text-slate-300 transition-colors hover:bg-white/10"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
          <span className="font-extrabold tracking-tight text-white">KALYX</span>
        </header>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-10">
          <div className={`animate-fade-up mx-auto ${wide ? "max-w-[1900px]" : "max-w-6xl"}`}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
